import logger from "./utils/logger";

const config = {};

config.REACT_APP_BASE_URL = "https://api-admin.tpaoficial.com/api/";

logger.debug('window._env_?.REACT_APP_BASE_URL: ',window._env_?.REACT_APP_BASE_URL)
logger.debug('config.REACT_APP_BASE_URL: ',config.REACT_APP_BASE_URL)

if(window._env_?.REACT_APP_BASE_URL === undefined){
    console.error("Falta configurar URL");
}

// API
if(config.REACT_APP_BASE_URL.indexOf("BASE_URL") >= 0){

  config.REACT_APP_BASE_URL = "https://api-admin-dev.tpaoficial.com/api/"  ;

}

// WEB / ADMIN
config.REACT_APP_ADMIN_URL =
  window._env_?.REACT_APP_ADMIN_URL === undefined ||
  window._env_?.REACT_APP_ADMIN_URL === "#ADMIN_URL#"
    ? "https://admin.tpaoficial.com"
    : window._env_?.REACT_APP_ADMIN_URL;


//config.REACT_APP_BASE_URL = "https://api-admin-dev.tpaoficial.com/api"

//console.log(window._env_);
//console.log(config);

export default config;